import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Candidate} from '../../../shared/models/candidate';
import {LogUtils} from '../../../shared/utils/log-utils';
import {Test} from '../../../shared/models/test';
import {TestType} from '../../../shared/enums/test-type';
import {CommonUtils} from '../../../shared/utils/common-utils';
import {TestBundle} from '../../../shared/models/test-bundle';
import {Duration} from 'moment';

@Component({
    selector: 'app-candidate-test-epq',
    templateUrl: './candidate-test-epq.component.html',
    styleUrls: ['./candidate-test-epq.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CandidateTestEpqComponent {
    public selectedTab = 0;

    @Input() candidate: Candidate = null;
    @Input() selectedBundle = 0;

    get test(): Test {
        return this.bundle && this.bundle.tests ? this.bundle.tests.find(test => test.type === TestType.EPQ) : {} as Test;
    }

    get bundle(): TestBundle {
        if (this.candidate && CommonUtils.isNotEmpty(this.candidate.bundles)) {
            return this.candidate.bundles[this.selectedBundle];
        }
        return {} as TestBundle;
    }

    /**
     * result: { answers: object result: object}
     */
    get result(): { answers: object, result: object } {
        try {
            return JSON.parse(this.test.result);
        } catch (e) {
            LogUtils.error(`Parse error for results: ${e.message}`);
            return null;
        }
    }

    get answers(): string[] {
        if (this.test && CommonUtils.isNotEmpty(this.test.answers)) {
            return this.test.answers.slice(1, -1).split(', ');
        }
        return [];
    }

    get analysis(): any {
        return this.result ? this.result.result : {};
    }

    get renderData(): boolean {
        return this.answers && this.answers.length > 0;
    }

    get duration(): Duration {
        return CommonUtils.calculateDuration(this.test);
    }

    switchTab(index): void {
        this.selectedTab = index || 0;
    }
}
